const _ = require('lodash'), inspirationCardFactory = require('./inspiration-card-factory'), featureCardFactory = require('../feature-card/feature-card-factory');

module.exports = function mergeInspirationFeatureCards(cards, inspirationCards, pageNumber, pageSize, totalCardCount, featureCards) {
    // Return just the cards if no inspiration or feature cards to merge
    if (!inspirationCards && !featureCards) {
        return cards;
    }

    function mergeCards(cardDetails, cardFactory) {
        const currentPage = pageNumber * pageSize;
        const prevPage = pageSize * (pageNumber - 1);

        const cardFirstIndex = Object.keys(cardDetails)[0];

        let counter = 0;

        function negative(n) {
            return n < 0;
        }

        _.forEach(cardDetails, function (detailCard, position) {

            if (parseInt(position) <= currentPage && (parseInt(position) === 0 && parseInt(position) >= prevPage || parseInt(position) > prevPage) && parseInt(position) <= totalCardCount) {
                const calculatedPosition = (prevPage + counter) - position;
                const positionInCardList = negative(calculatedPosition) ? Math.abs(calculatedPosition) : calculatedPosition;

                Array.prototype.splice.apply(cards, [positionInCardList, 0]
                    .concat(cardFactory(detailCard)));
            } else {
                counter++;
            }

        });

        if (cardFirstIndex > totalCardCount) {
            Array.prototype.splice.apply(cards, [totalCardCount, 0]
                .concat(cardFactory(cardDetails[cardFirstIndex])));
        }
    }

    if (featureCards) {
        mergeCards(featureCards, featureCardFactory.createFeatureCards);
    }

    if (inspirationCards) {
        mergeCards(inspirationCards, inspirationCardFactory.createInspirationCards);
    }

    return cards;
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/inspiration/merge-inspiration-cards.js
 **/